<template>
  <div class='report-item report-item--agreement-graph' :style='{backgroundColor: computedBackgroundColor}'>
    <div class="text">
      <ContentEditable class='content-title' :style='{color: computedTitleColor}' :font-scale='computedTitleSize' :html='false' :editable='editable' :translated='$t(content.title, "title", this.tag)' tag='h1' v-model='content.title'></ContentEditable>
      <ContentEditable class='content-text' :style='{color: computedTextColor}' :font-scale='computedTextSize' :html='false' :editable='editable' :translated='$t(content.text, "text", this.tag)' tag='div' v-model='content.text'></ContentEditable>
      <div ref='graph' class="graph" @mouseleave='hideReport($event)'>
        <div :ref='"entry_" + i' :class='["entry", showingReport === i ? "selected" : ""]' @mouseenter='showReport(i, $event)' @click='showReport(i, $event)' v-if='config.exclusions.indexOf(bar.questionKey) === -1' v-for='bar, i in bars'>
          <div class='bar'>
            <div class="bar-background brand-background-color">
              <div class="bar-fill" :style='barStyle(bar)'></div>
            </div>
          </div>
          <span class='value'>{{bar.pc | decimalToPercent}}</span>
          <p v-if='editable'><a @click.prevent='removeBar(i)'><ion-icon name='close'></ion-icon></a></p>
        </div>
        <div ref='miniReport' :style='reportStyles' :class='["mini-report question-report", showingReport !== false ? "showing" : ""]'>
          <div class='mini-report--content'>
            <a class="close" @click.prevent='hideReport'><ion-icon name='close'></ion-icon></a>
            <QuestionBreakdown :translationContext='this.tag' :mini='true' :data='currentReport' class='mini' v-if='currentReport'></QuestionBreakdown>
            <div ref='caret' class='caret'></div>
          </div>
        </div>
      </div>
    </div>
    <div v-if='editable'>
      <UIActions @add='onAdd' @delete='onDelete' @edit='onEdit'></UIActions>
    </div>
  </div>
</template>
<script>
import UIActions from './UIActions.vue'
import ContentEditable from '../../ContentEditable.vue'
import Filters from '../../mixins/Filters';
import QuestionBreakdown from './QuestionBreakdown.vue'
import ViewMixin from '../../mixins/ViewMixin'
import TranslationMixin from '../lib/TranslationMixin'
export default {
  props: {
    config: {default: ()=>{{}}, type: Object},
    report: {default: ()=>({}), type: Object},
    response: {type: Object, default: ()=>{{}}},
    editable: {default: true, type: Boolean}
  },
  mixins: [Filters, ViewMixin, TranslationMixin],
  data () {
    return {
      content: {},
      ready: false,
      bars: [],
      showingReport: false,
      currentReport: null
    }
  },
  components: {
    UIActions,
    ContentEditable,
    QuestionBreakdown
  },
  methods: {
    removeBar (i) {
      this.config.exclusions.push(this.bars[i].questionKey)
    },
    showReport (i, event) {
      this.showingReport = i
      this.currentReport = this.bars[i]
      if(this.isTouch()){
        document.body.classList.add('noscroll')
      }
    },
    hideReport (event) {
      this.showingReport = false;
      document.body.classList.remove('noscroll')
    },
    onEdit () {
      this.$emit('edit', {target: this, fields: null, editorClass: 'AgreementGraphEditPanel'})
    },
    onAdd () {
      this.$emit('add')
    },
    onDelete () {
      this.$emit('delete')
    },
    barStyle (bar) {
      return {
        height: Math.round(bar.pc * 100, 2) + '%',
        backgroundColor: this.config.theme.barColor || this.globalTheme.chartSelectionColor
      }
    }
  },
  inject: ['globalTheme'],
  computed: {
    theme () {
      let themeOptions = {
        circleColor: this.config.theme.barColor
      }
      return {
        ...themeOptions,
        ...this.config.theme
      }
    },
    computedBackgroundColor () {
      return this.config.theme.backgroundColor || this.globalTheme.brandColor
    },
    computedTitleSize () {
      return this.config.theme.titleFontSize || this.globalTheme.titleFontSize
    },
    computedTextSize () {
      return this.config.theme.textFontSize || this.globalTheme.textFontSize
    },
    computedTitleColor () {
      return this.config.theme.titleColor || this.globalTheme.brandTitleColor
    },
    computedTextColor () {
      return this.config.theme.textColor || this.globalTheme.brandTextColor
    },
    reportStyles () {
      let entryElements = this.$refs["entry_" + this.showingReport];
      let entryElement, barElement, graphElement
      graphElement = this.$refs.graph
      if(typeof graphElement === 'undefined'){
        return
      }
      let graphWidth = graphElement.clientWidth
      let miniReportElement = this.$refs.miniReport;
      let caret = this.$refs.caret;
      let style = {}
      if(document.body.classList.contains('touch')){
        return
      }
      if (typeof entryElements !== 'undefined'){
        entryElement = entryElements[0]
        barElement = entryElement.querySelector('.bar-fill')
        let xOffset, yOffset, caretOffsetPc, caretOffset;
        xOffset = entryElement.offsetLeft + (entryElement.clientWidth/2)
        - (miniReportElement.clientWidth/2)
        yOffset = -(barElement.clientHeight + 40)

        let range = miniReportElement.clientWidth

        if (xOffset < 0){
          xOffset = -50
          caretOffset = 57.5 + (entryElement.offsetLeft)
        }
        if (xOffset > 0) {
          caretOffset = (range/2) - 25
        }
        if (xOffset > (graphWidth - miniReportElement.clientWidth)){
          xOffset = (graphWidth - miniReportElement.clientWidth) + 50
          caretOffset = (range - 50) - (graphWidth - entryElement.offsetLeft) + 7.5
        }

        let transform = `translate(${xOffset}px, ${yOffset}px)`;
        style.transform = transform;
        let caretTransform = `translateX(${caretOffset}px) rotate(45deg)`
        caret.style.transform = caretTransform
        return style
      } else if (typeof miniReportElement !== 'undefined') {
        return {
          left: miniReportElement.style.left,
          transform: miniReportElement.style.transform
        }
      }

    }
  },
  created () {
    let ordered = []
    this.content = this.config
    if (!this.response || !this.response.result) {
      let questions = this.report.questions
      for (let key in questions) {
        if(this.config.exclusions.indexOf(key) !== -1){
          continue
        }

        let question = {answer: '', pc: Math.random()}
        ordered.push({questionKey: key, question: this.report.questions[key], stats: this.report.stats[key], ...question, answers: this.report.answers[key]})
      }
    } else {
      // let questions = this.response.result.agreement.questions
      let questions = this.report.questions
      for (let key in questions){
        if(this.config.exclusions.indexOf(key) !== -1){
          continue
        }
        if (!this.response.result || typeof this.response.result.agreement.questions[key] === 'undefined') {
          continue
        }
        let answer = this.response.result.agreement.questions[key].answer
        if (typeof answer === 'undefined') {
          continue
        }
        let pc
        if (Array.isArray(answer)) {
          let totalPcs = 0
          for (let selection of answer) {
            let aResult = this.report.stats[key][selection]
            totalPcs += aResult.percent
          }
          pc = totalPcs / answer.length
          if (isNaN(pc)) {
            pc = 0
          }
        } else {
          if (typeof this.report.stats[key][answer] === 'undefined') {
            console.log(`Statistic value not found for key: ${key} with answer: ${answer}`)
            pc = 0
          } else {
            pc = this.report.stats[key][answer].percent
          }

        }
        let question = {
          answer: answer,
          pc: pc
        }
        ordered.push({questionKey: key, question: this.report.questions[key], stats: this.report.stats[key], ...question, answers: this.report.answers[key]})
      }
    }

    ordered = ordered.sort((a, b)=>{
      if (a.pc < b.pc){
        return -1
      }
      if (a.pc > b.pc) {
        return 1
      }
      return 0
    }).reverse()
    this.bars = ordered

    this.save = _.debounce(function(content){
        this.$store.dispatch('saveItem', content)
    }, 500)
  },
  watch: {
    content: {
      handler: function(content){
        if(!this.ready){
          this.ready = true
          return
        }
        this.$store.commit('setDirty', true)
        this.save(content)
      },
      deep: true
    }
  }
}
</script>
<style lang='scss'>
  .report-item.report-item--agreement-graph {
      .mini-report {
        .question-breakdown p {
          color: #efefef;
        }
        .bars .question {
          .progress-bar {
            background-color: #666;
            .progress {
              background-color: #dadada;
            }
          }
        }
    }
  }

</style>
<style lang='scss' scoped>
  @import '../../../../scss/components/variables';
  @import '../../../../scss/components/form';
  @import '../scss/report_items';

  .touch {
    .report-item.report-item--agreement-graph {
      .mini-report {
        pointer-events: none;
        position: fixed;
        top:0;
        bottom:0;
        left:0;
        right:0;
        z-index: 10;
        background-color: rgba(255,255,255,0.7);
        .mini-report--content {
          position: absolute;
          top: 20px;
          bottom: 20px;
          left: 20px;
          right: 20px;
          overflow: scroll;
          margin: auto;
          width: auto;
        }
        opacity: 0;
        width: auto;
        margin: auto;
        transform: translateY(0);
        .close {
          display: block;
          position: absolute;
          right: 10px;
          top: 10px;
          font-size: 20px;
          width: 30px;
          height: 30px;
          z-index: 2;
          text-align: right;
        }
        .question-breakdown {
          position: relative;
          z-index: 1;
        }
        .caret {
          display: none;
        }
        &.showing {
          //display: block;
          opacity: 1;
          pointer-events: auto;
        }
      }
    }
  }

  .report-item.report-item--agreement-graph {
    //display: none;
    padding-bottom: 3rem;
    @media (min-width: 768px) {
      display: block;
    }
    .mini-report {
      pointer-events: none;
      position: absolute;
      opacity: 0;
      transform: translateY(-95%);
      transition: 0.3s opacity;
      background-color: transparent;
      width: 50%;
      bottom: 0;
      left:0;
      z-index: 10;
      &.showing {
        opacity: 1;
        pointer-events: none;
      }
    }
    .mini-report--content {
      border-radius: 10px;
      padding: 1rem;

      min-height: 250px;
      background-color: black;
      color: white;
      .close {
        display: none;
      }
      .caret {
        background-color: inherit;
        position: absolute;
        bottom: -25px;
        left: 0;
        margin:auto;
        width: 50px;
        height: 50px;
        transform: translateX(50%) rotate(45deg);
        z-index: 1;
      }
      .question-breakdown {
        position: relative;
        z-index: 2;
        hr {
          margin-bottom: 1.5rem;
        }
      }
    }
    .report-placeholder {
      display: flex;
      padding: 2rem 0 0;
      justify-content: center;
      align-items: center;
      img {
        opacity: 0.5;
      }
    }
    .graph {
      display: flex;
      min-height: 200px;
      height: 30vh;
      position: relative;
      margin-top: 1.5rem;
      .entry {
        z-index: 1;
        &.selected {
        }
        span {
          display: inline-block;
          margin-top: 1rem;
        }
        position: relative;
        text-align: center;
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: 10px;

        span.value {
          font-size: 11px;
          @media (min-width: 768px) {
            display: inline-block;
          }
        }

        & + .entry {

        }
        .bar {
          height: 100%;
          padding: 0 5px;
          .bar-background {
            border-radius: 5px;
            height: 100%;
            background-color: #efefef;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
          }
          .bar-fill {
            border-radius: 5px;
            min-height: 1px;
            width: 100%;
          }

        }
      }
    }
  }
</style>